import { onContentLoaded } from './on_content_loaded';
import { varsFromServer } from './client_side_injection_vars';
import cookie from 'js-cookie';

function setLanguageCookie(newLocaleCode, days = 30) {
  cookie.set('language_locale', newLocaleCode, { expires: days, path: '/' });
}

onContentLoaded(() => {
  const languageDropdown = document.getElementById('languageDropdown');

  if (!languageDropdown) {
    return;
  }

  languageDropdown.addEventListener('change', () => {
    const { locale: currentLocale } = varsFromServer;
    const { pathname: currentPathName, search: locationQueryParams } = window.location;
    const currentRouteNoStartingSlash = currentPathName.replace(/^\//, '');
    const currentRoute = currentRouteNoStartingSlash.replace(new RegExp(`${currentLocale}/?`), '');

    const { value: languageValue } = languageDropdown;

    if (languageValue !== currentLocale) {
      setLanguageCookie(languageValue);
      if (languageValue !== 'en-US') {
        window.location = `/${languageValue}/${currentRoute}${locationQueryParams || ''}`;
      } else {
        window.location = `/${currentRoute}${locationQueryParams || ''}`;
      }
    }
  });
});
